<template>
  <div class="position-relative p-3">
    <!-- Header Summary Block -->
    <!-- <b-row class="mb-4">
      <b-col md="12">
        <div class="header-banner rounded p-4 d-flex align-items-center justify-content-between text-white shadow-sm overflow-hidden position-relative">
          <div class="banner-content z-index-2">
            <h4 class="font-weight-bold mb-1">
              <md-icon size="24" class="mr-2 banner-icon">public</md-icon> Geographic Fleet Analytics
            </h4>
            <p class="mb-0 text-white-50 small opacity-75">
              Identifying high-frequency delivery hubs and regional vehicle density patterns.
            </p>
          </div>
          <div class="banner-graph opacity-25 position-absolute" style="right: -20px; bottom: -10px;">
             <md-icon size="120">explore</md-icon>
          </div>
        </div>
      </b-col>
    </b-row> -->

    <b-row>
      <!-- Top Used Locations / Hubs -->
      <b-col md="7">
        <b-card shadow-sm class="mb-4 border-0 position-relative overflow-hidden glass-card">
          <div v-if="tripLoading" class="loading-overlay">
            <b-spinner small variant="primary"></b-spinner>
          </div>
          <div :class="{'loading-blur': tripLoading}">
            <div class="d-flex justify-content-between align-items-center mb-3">
              <h6 class="font-weight-bold mb-0">
                <md-icon size="18" class="mr-2 text-primary">location_on</md-icon> TOP USED LOCATIONS / HUBS
              </h6>
              
              <b-form-radio-group
                v-model="selectedRole"
                :options="roleOptions"
                buttons
                size="sm"
                button-variant="outline-primary"
                class="role-selector-pills"
                @change="$emit('role-change', $event)"
              ></b-form-radio-group>
            </div>
            <apexchart type="bar" height="380" :options="tripTrendsOptions" :series="tripTrendsSeries"></apexchart>
          </div>
        </b-card>
      </b-col>

      <!-- Vehicles Per Hub (Density) -->
      <b-col md="5">
        <b-card shadow-sm class="mb-4 border-0 position-relative overflow-hidden glass-card h-100">
          <div v-if="densityLoading" class="loading-overlay">
            <b-spinner small variant="primary"></b-spinner>
          </div>
          <div :class="{'loading-blur': densityLoading}" class="d-flex flex-column h-100">
            <div class="d-flex justify-content-between align-items-center mb-3">
              <h6 class="font-weight-bold mb-0 text-uppercase">
                <md-icon size="18" class="mr-2 text-info">local_shipping</md-icon> VEHICLES PER HUB (DENSITY)
              </h6>
            </div>

            <div class="table-responsive flex-grow-1">
              <table class="table custom-density-table mb-0">
                <thead>
                  <tr class="bg-light-soft text-muted text-uppercase xs-font">
                    <th class="border-0 font-weight-bold">Hub / Location</th>
                    <th class="border-0 font-weight-bold text-center">Active Veh.</th>
                    <th class="border-0 font-weight-bold text-right">Avg Turnaround</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in densityData" :key="index" class="align-middle">
                    <td class="border-0 py-3">
                      <div class="font-weight-bold text-dark">{{ item.location }}</div>
                      <div class="xs-font text-muted text-uppercase">{{ item.region }}</div>
                    </td>
                    <td class="border-0 py-3 text-center">
                       <b-badge pill variant="primary" class="density-badge px-3 py-1">{{ item.activeVehicles }}</b-badge>
                    </td>
                    <td class="border-0 py-3 text-right">
                      <span class="text-muted">{{ item.avgTurnaround }}</span>
                    </td>
                  </tr>
                  <tr v-if="!densityData || densityData.length === 0">
                    <td colspan="3" class="text-center py-5 text-muted small">No hub density data available</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'LocationIntelligenceTab',
  props: {
    tripTrendsSeries: { type: Array, required: true },
    tripTrendsOptions: { type: Object, required: true },
    densityData: { type: Array, default: () => [] },
    tripLoading: { type: Boolean, default: false },
    densityLoading: { type: Boolean, default: false },
    initialRole: { type: String, default: 'PODLocationId' }
  },
  data() {
    return {
      selectedRole: this.initialRole,
      roleOptions: [
        { text: 'Destination', value: 'PODLocationId' },
        { text: 'Pickup', value: 'pickupLocationId' },
        { text: 'Stuffing', value: 'stuffingLocationId' },
        { text: 'Handover', value: 'handoverLocationId' }
      ]
    };
  },
  watch: {
    initialRole(newVal) {
      this.selectedRole = newVal;
    }
  }
};
</script>

<style scoped>
.header-banner {
  background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);
  border-left: 5px solid #3b82f6;
}
.banner-icon { color: #60a5fa; }
.glass-card {
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 15px rgba(0,0,0,0.05);
}
.loading-overlay {
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(255, 255, 255, 0.7);
  display: flex; align-items: center; justify-content: center;
  z-index: 10; backdrop-filter: blur(2px);
}
.loading-blur { filter: blur(2px); opacity: 0.6; }

.custom-density-table thead th {
  padding: 12px 16px;
  background: #f8fafc;
  color: #64748b;
  font-size: 0.65rem;
  letter-spacing: 0.05em;
}
.custom-density-table tbody tr {
  border-bottom: 1px solid #f1f5f9;
  transition: background 0.2s;
}
.custom-density-table tbody tr:hover {
  background: #f8fafc;
}
.bg-light-soft { background-color: #f8fafc !important; }
.xs-font { font-size: 0.65rem; }
.density-badge {
  font-weight: 600;
  box-shadow: 0 2px 4px rgba(59, 130, 246, 0.2);
}
</style>



// WEBPACK FOOTER //
// LocationIntelligenceTab.vue?2616df9e